var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNauseaSliderIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.39 113.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-nausea-slider,.cls-2-nausea-slider{fill:none;stroke:#fff;stroke-width:3px;}.cls-1-nausea-slider{stroke-miterlimit:10;}.cls-2-nausea-slider{stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-nausea-slider",
    cx: 57.56,
    cy: 57.47,
    r: 42.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-nausea-slider",
    x1: 38.31,
    y1: 55.89,
    x2: 47.4,
    y2: 55.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-nausea-slider",
    x1: 42.86,
    y1: 50.97,
    x2: 42.86,
    y2: 60.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-nausea-slider",
    x1: 68.31,
    y1: 55.89,
    x2: 77.4,
    y2: 55.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-nausea-slider",
    x1: 72.86,
    y1: 50.97,
    x2: 72.86,
    y2: 60.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-nausea-slider",
    d: "M48.19,76.41s3.37-3,10.37-3c6.5,0,9.32,3,9.32,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-nausea-slider",
    d: "M48.87,37.9s-1,3.36-5.55,6.15c-4.25,2.59-7.31,1.7-7.31,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-nausea-slider",
    d: "M67,37.9s1,3.36,5.54,6.15c4.25,2.59,7.32,1.7,7.32,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-nausea-slider",
    d: "M42.44,75a6.63,6.63,0,0,1,6,1.75,5.69,5.69,0,0,1,1.35,5.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-nausea-slider",
    d: "M74,75a6.66,6.66,0,0,0-6,1.75,5.72,5.72,0,0,0-1.35,5.59"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNauseaSliderIcon4);
export default __webpack_public_path__ + "static/media/nausea_slider_icon_4.3d6fcf8e.svg";
export { ForwardRef as ReactComponent };